import { render, staticRenderFns } from "./GetPrize.vue?vue&type=template&id=909144b0&scoped=true&"
import script from "./GetPrize.vue?vue&type=script&lang=js&"
export * from "./GetPrize.vue?vue&type=script&lang=js&"
import style0 from "./GetPrize.vue?vue&type=style&index=0&id=909144b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "909144b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data-jenkins/jenkins/workspace/html-cube-webapi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('909144b0')) {
      api.createRecord('909144b0', component.options)
    } else {
      api.reload('909144b0', component.options)
    }
    module.hot.accept("./GetPrize.vue?vue&type=template&id=909144b0&scoped=true&", function () {
      api.rerender('909144b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ActivityData/GetPrize.vue"
export default component.exports